import { Button } from '@mui/material'
import { CustomTableData } from 'common'
import { TooltipInformation } from 'common'
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import React from 'react'
import { DownloadCloud, Edit3, FileText, Info, Trash2 } from 'react-feather'

export const ManagementsTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const {fetchAllManagements, } = FetchData 
    const {managements} = fetchAllManagements 
    const {handleClickInfoManagement, handleClickDeleteManagement, generatePDF, generateCotizacionPDF} = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation
                                idregistro={idcontrato}
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { field: "gestion_codigo", headerName: "IDENTIFICADOR", minWidth: 160, filter: true },
        { field: "gestion_tipo", headerName: "TIPO", minWidth: 220, filter: true },
        { field: "gestion_fecha", headerName: "FECHA GESTION", minWidth: 160, filter: true },
        { field: "tipo_cuota", headerName: "TIPO DE CUOTA", minWidth: 280, filter: true },
        { field: "nombre", headerName: "DATOS DEL CLIENTE", minWidth: 280, filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 200,
            maxWidth: 200,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellClass: (params) => {

                if(params.value === 'Pendiente Aprobacion') return 'bg-warning';
                if(params.value === 'Pendiente Contrato') return 'bg-warning';
                if(params.value === 'Rechazado') return 'bg-danger';
                if(params.value === 'Aprobado') return 'bg-success';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { idcontrato, aprobacion_usuario, aprobacion_fecha } = params.data
                if(value === 'Aprobado') return (
                    <TooltipAprobacion
                    tag_id='tooltip_arr_solicitudes_aprobacion_'
                    class_icon='fa-solid fa-check-circle'
                    text_span='Aprobado'
                    idcontrato={idcontrato}
                    aprobacion_usuario={aprobacion_usuario}
                    aprobacion_fecha={aprobacion_fecha}
                />
                )

                if(value === 'Pendiente Aprobacion') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-user-clock'
                        text_span='Pendiente Aprobacion'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

                if(value === 'Pendiente Contrato') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-user-clock'
                        text_span='Pendiente Contrato'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

                if(value === 'Rechazado') return (
                    <TooltipAprobacion
                        tag_id='tooltip_arr_solicitudes_aprobacion_'
                        class_icon='fa-solid fa-circle-xmark'
                        text_span='Rechazado'
                        idcontrato={idcontrato}
                        aprobacion_usuario={aprobacion_usuario}
                        aprobacion_fecha={aprobacion_fecha}
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idgestion} = params.data
                
                return(
                    <Button 
                        startIcon = { <Info/>}
                        variant='contained'
                        size='small' 
                        color='info'
                        sx={{ marginRight: '8px' }}
                        onClick={() => handleClickInfoManagement(idgestion, 'info')} 
                        style={ { width: 150 } }
                        > 
                        Solicitud
                    </Button>
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={managements}
                columnConfig={columnConfig}
            />
        </div>
    )
}

